export const DEFAULT_SCALE_VALUE = "auto";
export const DEFAULT_SCALE = 1.0;
export const DEFAULT_SCALE_DELTA = 1.1;
export const MIN_SCALE = 0.1;
export const MAX_SCALE = 10.0;
export const UNKNOWN_SCALE = 0;
export const MAX_AUTO_SCALE = 1.25;
export const SCROLLBAR_PADDING = 40;
export const VERTICAL_PADDING = 5;
export const PAGE_NUMBER_LOADING_INDICATOR = "visiblePageIsLoading";
export const PagesCountLimit = {
  FORCE_SCROLL_MODE_PAGE: 15000,
  FORCE_LAZY_PAGE_INIT: 7500,
  PAUSE_EAGER_PAGE_INIT: 250,
};

export const CursorTool = {
  SELECT: 0,
  HAND: 1,
  ZOOM: 2,
};

export const ScrollMode = {
  UNKNOWN: -1,
  VERTICAL: 0, // Default value.
  HORIZONTAL: 1,
  WRAPPED: 2,
  PAGE: 3,
};

/**
 * Promise that is resolved when DOM window becomes visible.
 */
export const animationStarted = new Promise(function (resolve) {
  window.requestAnimationFrame(resolve);
});

/**
 * Event handler to suppress context menu.
 */
export function noContextMenuHandler(evt) {
  evt.preventDefault();
}
